import React from 'react';
import _compact from "lodash/compact";
import _filter from 'lodash/filter';


const CityView = props => {

  const activeSectors = _filter(props.sectors, ['name', props.active]);
  const _cityData = _filter(props.cities, ["ctfl_id", activeSectors[0].city_ctfl_id])[0];


  const renderMustSees = (mustSees) => {
    if(mustSees === null) return [];
    const _mustSees = _compact(mustSees.split("- __"));
    const _mustSeesMod = _mustSees.map(item => item.replace('__', ' -'));
    const _titleAndDescription = _mustSeesMod.map(item => { return {"title": item.substring(0, item.indexOf('-')), "description": item.substring(item.indexOf('-')+1, item.length)} });
    return _titleAndDescription;
  }


  const mustSeesArray = renderMustSees(_cityData.mustSees);

  return (
    <div className="city-view" style={{display:mustSeesArray.length > 0 ? 'block' : 'none'}}>

      <div className="row">
        <div className="column small-12">
          <p className="no-margin grey-subtile-text">City Guide</p>
          <h5 className="busabout-h5">Must see &amp; do in {activeSectors[0].city}</h5>
          </div>
      </div>

      <div className="row margin-t-30">
        <div className="column small-12 medium-6">
          <p className="viking-text bold">
            <span className="ba-icon ba_icon_map_location"></span>
            The City
          </p>

          <p>{_cityData.descriptionLong}</p>

        </div>

        <div className="column small-12 medium-6">
            <p className="viking-text bold">
              <span className="ba-icon ba_icon_adventure"></span>
              Top Things To See
            </p>
              {
                mustSeesArray.map((item, i) => {
                  return (
                    <ul key={i}>
                      <li>
                        <p className="no-margin bold">{item.title}</p>
                        <p className="no-margin">{item.description}</p>
                      </li>
                    </ul>
                  )
                })
              }
        </div>
      </div>
    </div>
  )
}

export default React.memo(CityView);



// WEBPACK FOOTER //
// ./src/components/itinerary/city/components/city-view.js